// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".region-card {\n  position: relative;\n  padding: 4.667vw 5.2vw;\n  width: 44vw;\n  height: 44vw;\n  box-sizing: border-box;\n}\n.region-card:active {\n  filter: brightness(0.8);\n}\n.region-card-title {\n  position: relative;\n  z-index: 1;\n  font-size: 4.8vw;\n  font-weight: bold;\n  color: #fff;\n}\n.region-card-bg {\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 44vw;\n  height: 44vw;\n}\n", ""]);
// Exports
module.exports = exports;
